<div
  class="text-widget"
  [style.font-family]="fontFamily"
  [style.font-size.cqw]="fontSize"
  [style.font-weight]="smartTextWidget.font_weight || 'normal'"
  [style.color]="textColor"
  [style.text-align]="smartTextWidget.text_align || 'left'"
  [style.background-color]="smartTextWidget.background_color || 'transparent'"
  [style.opacity]="smartTextWidget.opacity || 1"
  [style.border-color]="smartTextWidget.border_color || 'transparent'"
  [style.border-width.cqw]="(smartTextWidget.border_width || 0) / 10"
  [style.border-style]="(smartTextWidget.border_width || 0) > 0 ? 'solid' : 'none'"
>
  <!-- NOTE for now, the smart text widget is just the auction url with a label
but we might want to add different campaign info in the future, update below as needed -->
  <span> {{ smartTextWidget.text }}{{ auctionValue }} </span>
</div>
